import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// Eagerly import the audio modules at app boot so their first-gesture
// "unlock" listeners attach BEFORE the user ever taps anything (including
// on the login or password-reset pages). Otherwise the user's first tap
// happens before the listeners exist and audio stays locked on iOS.
import "./lib/speech";
import "./lib/sfx";
import { installGlobalErrorListeners } from "./lib/errorReporter";
import { i18nReadyPromise } from "./i18n";

// Install BEFORE the first render so a crash thrown during the very
// first synchronous component evaluation still trips the listeners.
// (The React error boundary catches render errors INSIDE its subtree;
// these listeners cover everything outside it — pre-mount throws,
// async setTimeout exceptions, and unhandled promise rejections.)
installGlobalErrorListeners();

// Await i18n initialisation before first render. The promise resolves once
// the active locale (and English fallback) have been fetched and i18next
// is fully initialised. Individual chunk-load failures are caught inside
// i18nReadyPromise itself and degrade gracefully — the promise never rejects
// in normal operation. The outer .catch() here is a last-resort safety net
// for any unexpected rejection that escapes (e.g. i18next.init() itself
// throws): we log it and still mount so the app does not hang indefinitely.
void i18nReadyPromise
  .catch((err: unknown) => {
    console.error("[i18n] Unexpected init failure, mounting with degraded translations:", err);
  })
  .then(() => {
    createRoot(document.getElementById("root")!).render(<App />);
  });
